import { Node } from "../../src/shell/Actions/Action";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { empty } from "../characters/empty";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doImageShake, doLoopImages, doPhoneRing, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8EmilyKitchenNightBefore, V8VanessaMCNightAfter } from "./V8";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

const v8 = images.v8;

export const V8VanessaMCNight = async (): Promise<any> => {
    // TODO: ADD KICK HER OUT OPTION

    // TODO: either got back from Jenny's date or just chilled at his home
    // TODO: do you want to address Emily not in the house or allude to the potential of her walking in on them?
    empty.think(`*Noises*`);
    mc.think(`What the fuck is that noise? Did someone break in???`);
    // Vanessa at the front door.
    doWaitImageByTime(images.v8.V8VanessaMCNight_70);
    mc.talk(`Vanessa? What the fuck are you doing here?`);
    mc.talk(`Did you just break into my house?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_71);
    vanessa.talk(`It's not really a break-in if the door wasn't locked, is it?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_70);
    mc.talk(`...`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_71);
    vanessa.talk(`You should really do a better job locking up your house.`);
    vanessa.talk(`It's dangerous! Someone might get inside.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_70);
    mc.talk(`I can't imagine that would happen...`);
    mc.talk(`Come in I guess.`);
    doWaitImageByTime(images.v8.V8VanessaMCNight_0);
    mc.talk(`So, what are you doing here?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_1);
    vanessa.talk(`I just wanted to spend some time with you!`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_0);
    mc.talk(`Somehow I don't buy that...`);
    mc.talk(`What do you really want?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_72);
    vanessa.talk(`Fine! You know things are rough between me and Joe. I just wanted someplace I could spend some time with someone...`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_73);
    mc.talk(`I think I know what's going on...`);
    mc.talk(`Is this because of our little agreement?`);
    mc.talk(`You can't go around fucking whoever you want so you came here to get it from me.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_74);
    vanessa.talk(`What an absolutely ridiculous thing to say!`);
    doWaitImageByTime(images.v8.V8VanessaMCNight_2);
    vanessa.talk(`Listen, just do the stuff you normally do. I'll just sit right here and won't disturb you.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_3);
    vanessa.talk(`I just need some company! That's all. Promise!`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_2);
    mc.talk(`What are you going to do anyway?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_4);
    vanessa.talk(`I have the TV and my phone. Plenty to keep me occupied!`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_3);
    vanessa.talk(`Don't worry! I know how to keep myself busy.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_2);
    mc.talk(`Fine.`);
    vanessa.talk(`Great!`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_3);
    vanessa.talk(`Oh, by the way, would you mind if I change into my PJs?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_2);
    mc.talk(`Suit yourself...`);
    vanessa.talk(`Thanks!`);

    doWaitImageByTime(images.v8.V8VanessaMCNight_5);
    mc.think(`This is definitely distracting, but whatever...`);
    doTransition(images.v8.V8VanessaMCNight_6);
    empty.think(`Moaning noises.`);
    doWaitImageByTime(images.v8.V8VanessaMCNight_8);
    mc.think(`The fuck?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_8);
    mc.talk(`What the fuck?`);
    mc.talk(`Why are you naked?!?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_7);
    mc.talk(`And are you watching porn?!?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_9);
    vanessa.talk(`What? Me? No!`);
    vanessa.talk(`And I just changed into my PJs; you said you don't mind.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_6);
    mc.talk(`Whatever...`);
    doWaitImageByTime(images.v8.V8VanessaMCNight_11);
    vanessa.talk(`What are you doing?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_10);
    vanessa.talk(`You are just staring at your desktop.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_11.partials.V8VanessaMCNight_12, { putParent: true });
    mc.talk(`You know... It's kinda hard getting shit done with you around.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_11.partials.V8VanessaMCNight_13);
    vanessa.talk(`Why?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_14);
    mc.talk(`Do I really need to state the obvious?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_11.partials.V8VanessaMCNight_13, { putParent: true });
    vanessa.talk(`Just pretend that I'm not here!`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_11);
    mc.talk(`Fine.`);

    // dropping phone.

    doWaitImageByTime(images.v8.V8VanessaMCNight_15);
    doWaitImageByTime(images.v8.V8VanessaMCNight_16);
    doWaitImageByTime(images.v8.V8VanessaMCNight_17);
    vanessa.talk(`Oopsy! I dropped my phone!`);
    vanessa.talk(`How clumsy of me!`);
    vanessa.talk(`Let me just pick it up.`);
    doWaitImageByTime(images.v8.V8VanessaMCNight_18);
    vanessa.talk(`Where is it...?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_19);
    vanessa.talk(`It's so dark! I can't see shit!`);
    vanessa.talk(`I think I see it...`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_20);
    vanessa.talk(`There it is!`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_22);
    vanessa.talk(`Found it!`);
    mc.talk(`Great.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_23);
    vanessa.talk(`Crawling on the floor reminds me that I haven't worked out today!`);
    vanessa.talk(`Would you mind if I do some stretching?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_24);
    mc.talk(`Why are you talking to my dick?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_23);
    vanessa.talk(`No reason.`);
    vanessa.talk(`So? Can I?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_24);
    mc.talk(`Sure.`);

    doWaitImageByTime(images.v8.V8VanessaMCNight_25);
    mc.think(`This is getting out of hand!`);
    mc.think(`She is doing everything in her power to get me to fuck her.`);
    doWaitImageByTime(images.v8.V8VanessaMCNight_26);
    vanessa.talk(`Let me just stretch out for a bit...`, { method: `Mumbling to herself` });
    vanessa.talk(`I don't want my muscles to be tight in the morning!`, { method: `Mumbling to herself` });
    doWaitImageByTime(images.v8.V8VanessaMCNight_25.partials.V8VanessaMCNight_27, { putParent: true });
    await mc.setQuestion(new Question({ text: `Oh yeah. She's definitely trying to get me to fuck her!`, options: { think: true }, key: `v8VanessaNightFuckHer` })
        .option({ title: `Fuck her`, key: true })
        .option({ title: `Deny her`, key: false }));


    if (Question.globalAnswers.v8VanessaNightFuckHer) {
        return jump(V8VanessaMCNight_FuckHer, "V8VanessaMCNight_FuckHer");
    }

    return jump(V8VanessaMCNight_DenyHer, "V8VanessaMCNight_DenyHer");
};

export const V8VanessaMCNight_FuckHer = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8VanessaMCNight_28);
    mc.talk(`Come here.`);
    mc.talk(`I know why you came here.`);
    doImageShake(images.v8.Anim_V8VanessaMCNightDoggy.poster);
    mc.talk(`Is this what you want?`);
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightDoggy);
    vanessa.talk(`YESSS!!! GOD YESSSS!!!`);
    doWaitImageByTime(v8.V8VanessaMCNight_29);
    mc.talk(`If it is a fuck you want, then a fuck you'll get!`);
    vanessa.talk(`Yes!!! Give it to me! I need it sooo bad!`);
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightDoggy);
    mc.think(`I don't know how it's possible, but my cock just slid right inside her ass.`);
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightDoggy, { speed: 1.5 });
    vanessa.talk(`Harder!`);
    doWaitImageByTime(images.v8.V8VanessaMCNight_93, { wait: true });
    doWaitImageByTime(images.v8.V8VanessaMCNight_92);

    doPhoneRing();
    doWaitImageByTime(v8.V8VanessaMCNight_62);
    vanessa.talk(`Ah?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_63);
    await vanessa.setQuestion(new Question({ text: `Fuck! It's Joe!`, options: { think: false }, key: `v8JoeCallingAnsweredHim` })
        .option({ title: `Answer him`, key: true })
        .option({ title: `Ignore him`, key: false }));


    if (Question.globalAnswers.v8JoeCallingAnsweredHim) {
        return jump(V8VanessaMCNight_AnswerJoey, "V8VanessaMCNight_AnswerJoey");


    } else {

    }
    return jump(V8VanessaMCNight_IgnoreJoey, "V8VanessaMCNight_IgnoreJoey");


};

export const V8VanessaMCNight_AnswerJoey = async (): Promise<any> => {
    mc.talk(`Answer him.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_64);
    vanessa.talk(`Wow ${mc.name} can be kinky! I love it!!`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_65);
    vanessa.talk(`Hellooo...?`);
    joe.talk(`Hey...`, { method: "Over Phone" });
    vanessa.talk(`Hey honey!`);
    ImageClass.setImage(images.v8.Anim_V8VanessaMCNightDoggyPhone.poster);
    joe.talk(`Hey...`, { method: "Over Phone" });
    joe.talk(`Are you busy?`, { method: "Over Phone" });
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightDoggyPhone);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_68);
    vanessa.talk(`Fuck!`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
    vanessa.talk(`No.`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_67);
    joe.talk(`I can call later if this is a bad time.`, { method: "Over Phone" });

    // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
    vanessa.talk(`It's a perfect time. Mhhhhmmm.`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_67);
    joe.talk(`Oh, ok.`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
    joe.talk(`I wanted to talk to you, if you have a minute.`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_67);
    vanessa.talk(`Hmmmm. Sure, what's on your mind?`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
    joe.talk(`Well...`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_67);
    joe.talk(`It's not a secret our relationship has hit a rough spot lately.`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
    joe.talk(`We are trying to act like everything is normal, but things aren't.`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_67);
    joe.talk(`I also don't think that continuing to deny sex from me is the answer...`, { method: "Over Phone" });
    if (mc.properties.joeStatus === "friend") {
        if (Question.globalAnswers.v5JoeyBeachThreeSomeQuestion === "IWouldAgree") {
            // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
            joe.talk(`I was hoping the threesome with ${mc.name} would help solve things, but he refused...`, { method: "Over Phone" });
            // ImageClass.setImage(images.v8.V8VanessaMCNight_67);

        } else {
            // ImageClass.setImage(images.v8.V8VanessaMCNight_69);

        }


    } else {

    }
    joe.talk(`Are you still there?`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_68);
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightDoggy, { speed: 1.3 });
    vanessa.talk(`OH YES!!!`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
    vanessa.talk(`I mean, yes. I'm listening.`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_67);
    joe.talk(`I was hoping that maybe we could meet and talk about that.`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
    joe.talk(`Not just keep pretending everything is normal...`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_68);
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightDoggy, { speed: 1.6 });
    vanessa.talk(`FUCK YES!!!`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightDoggyPhone);
    vanessa.talk(`I totally agree!`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_67);
    joe.talk(`Are you sure you aren't busy?`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightDoggyPhone, { speed: 1.2 });
    vanessa.talk(`MMMhhhm. Just working out!`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_67);
    joe.talk(`Oh, I can call later.`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_69);
    vanessa.talk(`God yes!`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_67);
    vanessa.talk(`I mean no.`);
    ImageClass.setImage(images.v8.Anim_V8VanessaMCNightOnPhonePOV.poster);
    // vanessa.talk(`KEEP GOING! DON'T THINK ABOUT STOPPING!`);
    // ImageClass.setImage(images.v8.V8VanessaMCNight_76);
    joe.talk(`That's basically it...`, { method: "Over Phone" });
    // ImageClass.setImage(images.v8.V8VanessaMCNight_77);
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightOnPhonePOV);
    mc.talk(`Ahhh...`, { method: "Moaning Quietly" });
    vanessa.talk(`Are you cumming?`);
    doWaitImageByTime(v8.V8VanessaMCNight_78);
    joe.talk(`I didn't plan to, but I can come over right now if you want.`, { method: "Over Phone" });
    ImageClass.setImage(images.v8.V8VanessaMCNight_80);
    vanessa.talk(`I meant tomorrow?`);
    vanessa.talk(`Are you coming tomorrow?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_82);
    joe.talk(`Yes, I would love to.`, { method: "Over Phone" });
    ImageClass.setImage(images.v8.V8VanessaMCNight_80);
    vanessa.talk(`Great! *Slurp* So...`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_81);
    vanessa.talk(`*Slurp*`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_80);
    vanessa.talk(`I'll talk to you tomorrow.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_81);
    vanessa.talk(`Byeeeeee!`);
    doWaitImageByTime(images.v8.Anim_V8VanessaMCNightLickingDick.poster, { wait: true });
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightLickingDick, { loop: 0 });
    mc.talk(`Ah...`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_85);
    mc.talk(`That was fucked up.`);
    await endReplay(replayScenesList.v8VanessaAnal);

    ImageClass.setImage(images.v8.V8VanessaMCNight_85.partials.V8VanessaMCNight_85_p_talking, { putParent: true });
    vanessa.talk(`You told me to answer.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_85);
    mc.talk(`I know, but you were having way too much fun.`);

    ImageClass.setImage(images.v8.V8VanessaMCNight_85.partials.V8VanessaMCNight_85_p_talking);
    vanessa.talk(`What can I say? This entire situation really turned me on.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_85);
    mc.talk(`I saw...`);
    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v8.V8VanessaMCNight_85.partials.V8VanessaMCNight_85_p_talking);
        vanessa.talk(`Maybe next time we could call Ann... You'd like that wouldn't you?`);
    }

    vanessa.talk(`Anyways! It was fun, but I should really get my beauty sleep.`);

    return jump(V8VanessaMCNight_2, "V8VanessaMCNight_2");
};
export const V8VanessaMCNight_IgnoreJoey = async (): Promise<any> => {
    mc.talk(`Ignore him.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_64);
    vanessa.talk(`Alright!`);

    doWaitImageByTime(v8.V8VanessaMCNight_31);
    vanessa.talk(`Tired already?`);
    mc.talk(`No way!`);
    doImageShake(v8.V8VanessaMCNight_33);
    vanessa.talk(`Fuck!`);
    ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightMCAnalNoPhone);
    vanessa.talk(`Finally!`);
    vanessa.talk(`It's been soooo long!`);
    await mc.setQuestion(new Question({ text: `Her ass is too tight, I'm about to cum!`, options: { think: true }, key: `v8VanessaNightFuckHerWhereCum` })
        .option({ title: `Anal creampie`, key: `insideAss` })
        .option({ title: `Stomach`, key: `belly` })
        .option({ title: `Facial`, key: `face` }));


    ImageClass.setImage(images.v8.V8VanessaMCNight_33);
    if (Question.globalAnswers.v8VanessaNightFuckHerWhereCum === "insideAss") {
        mc.think(`I'm too close to pull out!`);
        doWaitImageByTime(v8.V8VanessaMCNight_34);
        mc.talk(`Ahh!!!`);
        vanessa.talk(`Thank you.`);

    } else if (Question.globalAnswers.v8VanessaNightFuckHerWhereCum === "belly") {
        mc.talk(`Ahhh!!!`);
        doWaitImageByTime(v8.V8VanessaMCNight_35);
        if (Question.globalAnswers.v8FuckedAngela) {
            vanessa.talk(`I'm glad to see you didn't waste everything on that girl today!`);
        }
        mc.talk(`I have plenty more where that came from.`);

    } else {
        mc.talk(`Fuck!`);
        doWaitImageByTime(images.v8.V8VanessaMCNight_36);

        ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightLickingDick);
        mc.talk(`Ahhh!!!`);
        doWaitImageByTime(images.v8.V8VanessaMCNight_37);
        vanessa.talk(`Slurp!`);
        mc.think(`She put it in her mouth even after it was in her ass!`);
        doWaitImageByTime(images.v8.V8VanessaMCNight_38);
        mc.think(`Damn...`);
        mc.talk(`You really were craving it.`);
    }
    doWaitImageByTime(v8.V8VanessaMCNight_85);
    mc.talk(`Now what?`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_85.partials.V8VanessaMCNight_85_p_talking);
    vanessa.talk(`Now, I can sleep.`);
    await endReplay(replayScenesList.v8VanessaAnal);

    return jump(V8VanessaMCNight_2, "V8VanessaMCNight_2");
};
export const V8VanessaMCNight_DenyHer = async (): Promise<any> => {
    mc.think(`Fuck it, I'm not going to fall for her tricks.`);
    ImageClass.setImage(images.v8.V8VanessaMCNight_25);
    mc.think(`She said she'd follow my lead, and this is part of it. She'll have to learn to deal with it.`);
    doWaitImageByTime(v8.V8VanessaMCNight_39);
    vanessa.talk(`Asshole!`, { method: "Mumbling To Herself" });

    doWaitImageByTime(v8.V8VanessaMCNight_42);
    vanessa.talk(`Can I see your hand for one second?`);
    doWaitImageByTime(v8.V8VanessaMCNight_41);
    await vanessa.setQuestion(new Question({ text: `Yes!!!`, options: { think: false }, key: `v8VanessaNightFingeredHer` })
        .option({ title: `Keep fingering her`, key: true })
        .option({ title: `Deny her`, key: false }));


    if (Question.globalAnswers.v8VanessaNightFingeredHer) {
        mc.think(`I'll give her some relief.`);
        doWaitImageByTime(v8.V8VanessaMCNight_46);
        mc.talk(`I'm not sure who is assaulting who at this point.`);
        vanessa.talk(`Well... You are inside of me.`);
        doWaitImageByTime(v8.V8VanessaMCNight_40);
        vanessa.talk(`Just keep going!`);
        doWaitImageByTime(v8.Anim_V8VanessaMCNightFingering.poster);
        vanessa.talk(`Oh yeah! Fuck!`);
        ImageClass.setAnimation(v8.Anim_V8VanessaMCNightFingering);
        vanessa.talk(`YES! Keep going!`);
        vanessa.talk(`Don't stop!`);
        ImageClass.setAnimation(v8.Anim_V8VanessaMCNightFingering, { speed: 1.4 });
        vanessa.talk(`Ahh!!!`);
        doWaitImageByTime(v8.V8VanessaMCNight_44);
        mc.talk(`Damn...`);
        //
        vanessa.talk(`Fuck I needed that sooo much.`);
        doWaitImageByTime(v8.V8VanessaMCNight_44.partials.V8VanessaMCNight_45);
        mc.talk(`You are dripping.`);
        vanessa.talk(`No shit!`);
        // TODO: standing in front of the MC smiling
        mc.talk(`Now what?`);
        vanessa.talk(`Now I can sleep.`);
        endReplay(replayScenesList.v8VanessaFingering);

    } else {
        ImageClass.setImage(images.v8.V8VanessaMCNight_46);
        mc.talk(`What do you think you are doing?`);
        ImageClass.setImage(images.v8.V8VanessaMCNight_47);
        mc.talk(`Stop it!`);
        ImageClass.setImage(images.v8.V8VanessaMCNight_48);
        vanessa.talk(`You are such an asshole!`);
        mc.talk(`We said you would follow my lead, so follow it!`);

        mc.talk(`This is what it takes, deal with it!`);
        vanessa.talk(`Asshole!`);
        mc.talk(`...`);
        vanessa.talk(`I'm going to sleep.`);
        await endReplay();
    }


    return jump(V8VanessaMCNight_2, "V8VanessaMCNight_2");
};

export const V8VanessaMCNight_2 = async (): Promise<any> => {
    if (Question.globalAnswers.v8VanessaNightFuckHerWhereCum === "face" || Question.globalAnswers.v8JoeCallingAnsweredHim) {
        ImageClass.setImage(images.v8.V8VanessaMCNight_85);
        mc.talk(`Are you going to wipe your face first?`);
        ImageClass.setImage(images.v8.V8VanessaMCNight_85.partials.V8VanessaMCNight_85_p_talking);
        vanessa.talk(`No way! It's the best face moisturizer.`);
        doWaitImageByTime(v8.V8VanessaMCNight_50);
        mc.talk(`You were serious...`);

    } else {

        doWaitImageByTime(v8.V8VanessaMCNight_49);
        mc.talk(`Here???`);
        ImageClass.setImage(v8.V8VanessaMCNight_50);
    }
    vanessa.talk(`I'll be gone before you wake up.`);
    doWaitImageByTime(v8.V8RoomNight.partials.V8RoomNight_0_p, { putParent: true });
    mc.talk(`The shit I have to deal with...`);
    doTransition(v8.V8RoomNight.partials.V8RoomNight_0_p, { putParent: true });
    mc.think(`It's time to get some sleep.`);
    if (Question.globalAnswers.v8VanessaNightFuckHerWhereCum === "face" || Question.globalAnswers.v8JoeCallingAnsweredHim) {
        doWaitImageByTime(v8.V8VanessaMCNight_88);
        mc.think(`Look at her sleeping like a princess...`);
        ImageClass.setImage(v8.V8VanessaMCNight_89);
        mc.think(`A princess with my cum all over her face...`);

    } else {

        doWaitImageByTime(v8.V8VanessaMCNight_50);
        mc.think(`Vanessa is still here...`);
        mc.think(`She said she's gonna be gone in the morning.`);
    }


    doWaitImageByTime(v8.V8VanessaMCNight_51);
    mc.think(`Time to sleep...`);
    // mc.think(`...`);
    // mc.think(`Fuck. Now I'm thirsty...`);
    // mc.think(`I'll go grab a glass a water real quick.`);

    return jump(V8EmilyKitchenNightBefore, "V8EmilyKitchenNightBefore");


};
export const V8VanessaMCNightBackFromEmily = async (): Promise<any> => {
    doTransition(v8.V8VanessaMCNight_49);
    mc.think(`Vanessa is still sleeping like a rock.`);
    if (Question.globalAnswers.v8EmilyKitchenNightJoinHerBed) {
        doWaitImageByTime(v8.V8VanessaMCNight_51);
        mc.think(`Time for me to get some sleep as well.`);
        mc.think(`...`);
        mc.think(`......`);
        doWaitImageByTime(v8.V8VanessaMCNight_94);
        await mc.setQuestion(new Question({ text: `Fuck. I'm so horny right now, I can't sleep.`, options: { think: true }, key: `v8VanessaNightWakeHerUp` })
            .option({ title: `Wake up Vanessa`, key: true })
            .option({ title: `Just go to sleep`, key: false }));


        if (Question.globalAnswers.v8VanessaNightWakeHerUp) {
            mc.talk(`PST.`);
            mc.talk(`Vanessa.`);
            doWaitImageByTime(v8.V8VanessaMCNight_95);
            mc.talk(`Vanessa!`);
            vanessa.talk(`What do you want? I'm sleeping.`, { method: "Mumbling" });
            mc.talk(`I'm horny.`);
            vanessa.talk(`So masturbate.`, { method: "Mumbling" });
            mc.think(`Fuck.`);
            doWaitImageByTime(v8.V8VanessaMCNight_96);
            mc.think(`I have no choice...`);
            doLoopImages([images.v8.V8VanessaMCNight_101, images.v8.V8VanessaMCNight_96], 0.5);
            // ImageClass.setImage(images.v8.V8VanessaMCNight_101, { wait: 0.5 });
            // ImageClass.setImage(images.v8.V8VanessaMCNight_96, { wait: 0.5 });
            // ImageClass.setImage(images.v8.V8VanessaMCNight_101, { wait: 0.5 });
            mc.talk(`Ah...`);

            doWaitImageByTime(v8.V8VanessaMCNight_102);
            mc.think(`She turned around...`);
            mc.think(`She wants me to cum in her mouth! Who am I to say no.`);

            doWaitImageByTime(v8.V8VanessaMCNight_97);
            mc.talk(`Fuck!`);
            doWaitImageByTime(v8.V8VanessaMCNight_99);
            if (Question.globalAnswers.v8VanessaNightFuckHerWhereCum === "face" || Question.globalAnswers.v8JoeCallingAnsweredHim) {
                mc.think(`It's been a while but I can still see my previous cum on her face!`);
            } else {
                mc.think(`I needed that...`);

            }

            doWaitImageByTime(v8.V8VanessaMCNight_94);
            vanessa.talk(`Good night.`);
            mc.think(`Damn. This girl is so kinky.`);
            doWaitImageByTime(v8.V8VanessaMCNight_51);
            mc.think(`Now I can sleep.`);



        } else {
            doWaitImageByTime(v8.V8VanessaMCNight_51);
            mc.think(`Nah. I'll just go to sleep.`);
        }



    } else {
        doWaitImageByTime(v8.V8VanessaMCNight_51);
        mc.think(`Time to sleep for real...`);
    }


    return jump(V8VanessaMCNight_Morning, "V8VanessaMCNight_Morning");
};
export const V8VanessaMCNight_Morning = async (): Promise<any> => {

    if (Question.globalAnswers.v8VanessaNightFingeredHer === false) {
        doTransition(v8.V8VanessaMCNight_52);
        mc.think(`WHAT THE HELL?!?`);
        ImageClass.setImage(images.v8.V8VanessaMCNight_54);
        mc.talk(`Mmhmm?!`);
        ImageClass.setImage(images.v8.V8VanessaMCNight_53);
        await vanessa.setQuestion(new Question({ text: `JUST LICK IT!`, options: { think: false }, key: `v8VanessaNightLickHer` })
            .option({ title: `Lick`, key: true })
            .option({ title: `Push her down`, key: false }));


        if (Question.globalAnswers.v8VanessaNightLickHer) {
            mc.think(`Poor girl... I'll help her out.`);
            mc.think(`Besides... There is nothing better than pussy for breakfast!`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_55);
            vanessa.talk(`YES!!!`);
            ImageClass.setImage(images.v8.Anim_V8VanessaMCNightLicking.poster);
            vanessa.talk(`EAT IT!`);
            ImageClass.setAnimation(images.v8.Anim_V8VanessaMCNightLicking);
            vanessa.talk(`AHHH!!!`);
            doTransition(v8.V8VanessaMCNight_90);
            vanessa.talk(`Thank you!`);
            vanessa.talk(`Now I can start my day.`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_91);
            if (Question.globalAnswers.v7AteVanessaPussy) {
                mc.talk(`I'm starting to see a trend here...`);
                vanessa.talk(`I'm totally fine with that.`);

            }

        } else {
            await mc.set((properties) => {
                properties.v8NightDeniedVanessaCompletely = true;
            });
            vanessa.talk(`What the...?`, { wait: 0 });
            doWaitImageByTime(images.v8.V8VanessaMCNight_57, { hideText: false });
            doImageShake(v8.V8VanessaMCNight_58);
            vanessa.talk(`OUCH!`);
            mc.talk(`Enough is enough!`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_59);
            vanessa.talk(`What's wrong with you?`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_59.partials.V8VanessaMCNight_60);
            mc.talk(`Wrong with me?`);
            mc.talk(`We already talked about this!`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_59);
            vanessa.talk(`It's not my fault, I woke up and you kept teasing me!`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_59.partials.V8VanessaMCNight_60);
            mc.talk(`Teasing you? I was literally sleeping!`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_59);
            vanessa.talk(`Next time sleep with your mouth closed.`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_59.partials.V8VanessaMCNight_60);
            mc.talk(`I don't know how to respond to that.`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_59);
            vanessa.talk(`There is nothing more to say anyway.`);
            vanessa.talk(`I'm going home.`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_59.partials.V8VanessaMCNight_60);
            mc.talk(`Don't fuck anyone on your way out.`);
            doWaitImageByTime(images.v8.V8VanessaMCNight_90);
            vanessa.talk(`Ha!`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_91);
            vanessa.talk(`You can't blame a girl for trying.`);
            mc.talk(`Can you get out of here so I could go back to sleep?`);
            ImageClass.setImage(images.v8.V8VanessaMCNight_91.partials.V8VanessaMCNight_103_p);
            vanessa.talk(`Of course!`);

        }
        doWaitImageByTime(v8.V8VanessaMCNight_104);
        vanessa.talk(`See you in a second!`);
        mc.talk(`Wait! What's that supposed to mean?`);
        doWaitImageByTime(v8.V8VanessaMCNight_105);
        vanessa.talk(`BYEEEEE!`);
        doTransition(images.v9.V9VanessaMorning_20);
        mc.think(`Wow... Just wow...`);
        mc.think(`I'm still tired, I'll let my eyes rest for a couple of hours...`);
    }


    return jump(V8VanessaMCNightAfter, "V8VanessaMCNightAfter");
};
